/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import { Stack, Thumbnail, Button, TextStyle, Icon } from '@shopify/polaris';
import { DeleteMajor, DragHandleMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import noProductImage from 'src/assets/images/product/no-product-image.png';
import type { Product } from 'src/models/product';
import { optimizeImage } from 'src/helpers';

type Props = {
  product: Product,
  dragHandleProps: DraggableProvidedDragHandleProps,
  onRemove: (product: Product) => void
};

type ComposedProps = WithI18nProps & Props;

class RecommendProductItem extends Component<ComposedProps> {
  render() {
    const { dragHandleProps, product } = this.props;
    const { images } = product;
    let image = _.isEmpty(images)
      ? noProductImage
      : optimizeImage(images[Object.keys(images)[0]], '40x40');

    return (
      <div className="BC-Page__ManualRecommendation__RecommendProductItem">
        <Stack alignment="center">
          <div
            className="BC-Page__ManualRecommendation__RecommendProductItem__Draggable"
            {...dragHandleProps}>
            <Icon source={DragHandleMinor} color="subdued" />
          </div>
          <div className="BC-Page__ManualRecommendation__RecommendProductItem__Thumbnail">
            <Thumbnail source={image} size="small" />
          </div>
          <div className="BC-Page__ManualRecommendation__RecommendProductItem__Name">
            <TextStyle>{product?.title}</TextStyle>
          </div>
          <div className="BC-Page__ManualRecommendation__RecommendProductItem__Action">
            <Button size="slim" icon={DeleteMajor} plain onClick={this.handleRemove} />
          </div>
        </Stack>
      </div>
    );
  }

  handleRemove = () => {
    const { product, onRemove } = this.props;
    onRemove(product);
  };
}

export default withI18n()(RecommendProductItem);
